import { BrowserRouter, Route, Routes } from 'react-router-dom';
import RedirectPage from './pages/RedirectPage.jsx';
import NotFoundPage from './pages/NotFoundPage.jsx';

/**
 * Two routes only. /:qrCodeId is a scanned code; every other address on the
 * domain - /, /about, /a/b/c - is a dead end and shows the 404 page.
 *
 * A code that looks valid but the API does not know is handled inside
 * RedirectPage, which renders the same 404 page.
 */
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:qrCodeId" element={<RedirectPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}
